import React, { useMemo } from "react";

import { BadgeType } from "Components/Shipments/Maintenance/Documents/DocumentsItem/components/DocumentsBadge";
import { useCustomerPortalJobContext } from "Context/CustomerPortalJobContext";
import { useTranslation } from "react-i18next";

import { OrderTabDocumentStatusItem } from "./OrderTabDocumentStatusItem";
import {
  OrderTabDocumentStatusBody,
  OrderTabDocumentStatusContainer,
  OrderTabDocumentStatusTitle,
} from "./styles";

enum OrderTabMainDocuments {
  PASSPORT_COPY = "Passport Copy",
  BILL_OF_LADING = "Bill of Lading",
  CUSTOMS_FORM = "Customs Form",
}

export const OrderTabDocumentStatus = () => {
  const { documents } = useCustomerPortalJobContext();

  const { t: translate } = useTranslation();
  const headerDocuments = [
    OrderTabMainDocuments.PASSPORT_COPY,
    OrderTabMainDocuments.BILL_OF_LADING,
    OrderTabMainDocuments.CUSTOMS_FORM,
  ];

  const getBadgeType = (checked: boolean) => {
    if (checked) return BadgeType.SUCCESS;

    return BadgeType.ERROR;
  };

  const hasHeaderDocuments = useMemo(
    () =>
      !!documents?.find((document) =>
        Object.values(headerDocuments)
          ?.map((value) => value.toLowerCase())
          .includes(document.name.toLowerCase())
      ),
    [documents]
  );

  if (!hasHeaderDocuments) return null;

  return (
    <OrderTabDocumentStatusContainer>
      <OrderTabDocumentStatusTitle>
        {translate("yourMoveDocumentStatus")}
      </OrderTabDocumentStatusTitle>
      <OrderTabDocumentStatusBody>
        {headerDocuments?.map((item) => {
          const currentDocument = documents?.find(
            (document) => document.name.toLowerCase() === item.toLowerCase()
          );

          if (currentDocument) {
            return (
              <OrderTabDocumentStatusItem
                title={currentDocument.name}
                badgeText={currentDocument?.uploaded ? translate("uploaded") : translate("missing")}
                badgeType={getBadgeType(!!currentDocument?.uploaded)}
              />
            );
          }

          return <></>;
        })}
      </OrderTabDocumentStatusBody>
    </OrderTabDocumentStatusContainer>
  );
};
